// extracted by mini-css-extract-plugin
export default {"container":"o0-z","list":"p0-z"};